import { render } from "./UpdateLog.vue?vue&type=template&id=321f5d32"
import script from "./UpdateLog.vue?vue&type=script&lang=js"
export * from "./UpdateLog.vue?vue&type=script&lang=js"

import exportComponent from "/Users/user/Desktop/prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__